(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5001],{

/***/ 21152:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing-pages-v2/[...slug]",
      function () {
        return __webpack_require__(14215);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 49428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ StickyCTABarContextProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99758);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);



var StickyCTABarContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    visible: false,
    setVisible: function() {
        return null;
    }
});
var StickyCTABarContextProvider = function(param) {
    var children = param.children;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useState(false), 2), visible = ref[0], setVisible = ref[1];
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(StickyCTABarContext.Provider, {
        value: {
            visible: visible,
            setVisible: setVisible
        },
        children: children
    });
};


/***/ }),

/***/ 14215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.11.1_@types+react@18.3.28_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(78049);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/ContactSection.tsx
var ContactSection = __webpack_require__(80557);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/FCContactUs.tsx
var FCContactUs = __webpack_require__(99782);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/FCHero.tsx
var FCHero = __webpack_require__(95534);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/FCMap.tsx
var FCMap = __webpack_require__(49581);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/FCMissionStatement.tsx
var FCMissionStatement = __webpack_require__(81054);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/FCProductOptions.tsx
var FCProductOptions = __webpack_require__(72034);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/FCTestimonialCarousel.tsx
var FCTestimonialCarousel = __webpack_require__(96889);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/FCThreeSteps.tsx
var FCThreeSteps = __webpack_require__(23208);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/FCTrustBanner.tsx
var FCTrustBanner = __webpack_require__(43649);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/FCValueTracker.tsx
var FCValueTracker = __webpack_require__(21006);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/HeroV2.tsx + 3 modules
var HeroV2 = __webpack_require__(67236);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/HeroV2WithMarkers.tsx + 2 modules
var HeroV2WithMarkers = __webpack_require__(42465);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/LWCHeroCard.tsx
var LWCHeroCard = __webpack_require__(83530);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/LWCImageCard.tsx
var LWCImageCard = __webpack_require__(26923);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/LWCTextSection.tsx
var LWCTextSection = __webpack_require__(21277);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/MapBackgroundHero.tsx
var MapBackgroundHero = __webpack_require__(81131);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/PhotoTestimonials.tsx
var PhotoTestimonials = __webpack_require__(96309);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/Spacer.tsx
var Spacer = __webpack_require__(6902);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/StandaloneText.tsx
var StandaloneText = __webpack_require__(94479);
// EXTERNAL MODULE: ./src/cms/entries/dynamicEntry.ts
var dynamicEntry = __webpack_require__(42336);
;// CONCATENATED MODULE: ./src/cms/entries/homePageV2.ts




















// CarouselCards swaps mobile/desktop subtrees via useMedia, so it stays client-only.
var CarouselCards = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 9544).then(__webpack_require__.bind(__webpack_require__, 99544));
});
// Browser-only iframe runtime stays client-only.
var SuperIframe = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 2079).then(__webpack_require__.bind(__webpack_require__, 72079));
});
var TextBanner = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 1077).then(__webpack_require__.bind(__webpack_require__, 1077));
});
var homePageV2EntryLookup = {
    // only including blocks used in https://app.contentful.com/spaces/bjlp9d7o6h1o/entries/3jH3XGe228kfdp8fBGddyW?focusedField=slug
    // for performance
    block: {
        lpComponentMapBackgroundHero: MapBackgroundHero/* default */.Z,
        lpComponentCarouselCards: CarouselCards,
        lpComponentContactSection: ContactSection/* default */.Z,
        lpComponentLwcTextSection: LWCTextSection/* default */.Z,
        lpComponentLwcHeroCard: LWCHeroCard/* default */.Z,
        lpComponentLwcImageCard: LWCImageCard/* default */.Z,
        lpComponentHeroV2: HeroV2/* default */.ZP,
        lpComponentHeroV2WithMarkers: HeroV2WithMarkers/* default */.Z,
        lpComponentSpacer: Spacer/* default */.Z,
        lpComponentStandaloneText: StandaloneText/* default */.Z,
        fcHero: FCHero/* default */.Z,
        fcTrustBanner: FCTrustBanner/* default */.Z,
        fcValueTracker: FCValueTracker/* default */.Z,
        fcThreeSteps: FCThreeSteps/* default */.Z,
        fcProductOptions: FCProductOptions/* default */.Z,
        fcTestimonialCarousel: FCTestimonialCarousel/* default */.Z,
        fcMap: FCMap/* default */.Z,
        fcMissionStatement: FCMissionStatement/* default */.Z,
        fcContactUs: FCContactUs/* default */.Z,
        lpComponentTextBanner: TextBanner,
        lpComponentPhotoTestimonials: PhotoTestimonials/* default */.Z,
        componentSuperIframe: SuperIframe
    },
    inline: {}
};
/* harmony default export */ var homePageV2 = (homePageV2EntryLookup);

// EXTERNAL MODULE: ./src/cms/entries/landingPageV2.ts + 25 modules
var landingPageV2 = __webpack_require__(15283);
// EXTERNAL MODULE: ./src/cms/renderer/index.tsx
var renderer = __webpack_require__(51803);
// EXTERNAL MODULE: ./src/helpers/observability.ts + 1 modules
var observability = __webpack_require__(21562);
// EXTERNAL MODULE: ./src/helpers/ReturnExperienceContext.tsx
var ReturnExperienceContext = __webpack_require__(69814);
// EXTERNAL MODULE: ./src/helpers/StickyCTABarContext.tsx
var StickyCTABarContext = __webpack_require__(49428);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.29.0_@types+react-dom@18.3.7_@types+react@18.3.28__@types+rea_8a835da27f6bd732d06ca598c0c17f05/node_modules/next/router.js
var next_router = __webpack_require__(93287);
// EXTERNAL MODULE: ./src/pages/shared/LandingPageV2Layout.tsx + 2 modules
var LandingPageV2Layout = __webpack_require__(74486);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-scroll-parallax@3.5.0_@types+react-dom@18.3.7_@types+react@18.3.28__@types+react@_ada659bd4c285987d6e403ab25027445/node_modules/react-scroll-parallax/dist/index.mjs + 1 modules
var dist = __webpack_require__(81584);
;// CONCATENATED MODULE: ./src/pages/landing-pages-v2/[...slug].tsx













var LandingPageWithContext = function(props) {
    var trackJourneyEvent = (0,observability/* useObservability */.C3)().trackJourneyEvent;
    var router = (0,next_router.useRouter)();
    var nextJsPath = router.asPath.split("?")[0];
    var isHomePage = nextJsPath === "/"; // || true to debug HP perf
    var cmsEntryLookup = isHomePage ? homePageV2 : landingPageV2/* default */.Z;
    (0,react.useEffect)(function() {
        // only measuring homepage load-time performance
        if (false) {}
        // only measuring if the slug contains 'homepage'
        // we have a few variants of the homepage like /homepage-syw-v2-home-guide
        if (window.location.pathname !== "/") return;
        trackJourneyEvent("platform", "pageLoadedEvent", {
            // Next.js route, which is not necessarily the client-side URL
            routerPath: nextJsPath,
            loadTimeMs: Math.round(performance.now())
        });
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* ParallaxProvider */.Xu, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReturnExperienceContext/* ReturnExperienceContextProvider */.Q, {
            showReturnExperience: props.fields.showReturnExperienceBanner,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StickyCTABarContext/* StickyCTABarContextProvider */.H, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LandingPageV2Layout["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(renderer/* default.Component */.Z.Component, {
                        body: props.fields.body,
                        idToLoaderData: props.idToLoaderData,
                        entryLookup: cmsEntryLookup
                    })
                }))
            })
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var _slug_ = (LandingPageWithContext);


/***/ }),

/***/ 74486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ shared_LandingPageV2Layout; },
  "getJobPostingSchemaFromLoaderData": function() { return /* binding */ getJobPostingSchemaFromLoaderData; },
  "getLandingpageV2ServerSideProps": function() { return /* binding */ getLandingpageV2ServerSideProps; },
  "getPreloadsFromLoaderData": function() { return /* binding */ getPreloadsFromLoaderData; },
  "getSeoOverrideFromLoaderData": function() { return /* binding */ getSeoOverrideFromLoaderData; },
  "isMissingJobInLoaderData": function() { return /* binding */ isMissingJobInLoaderData; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(60947);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92336);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.11.1_@types+react@18.3.28_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(78049);
// EXTERNAL MODULE: ../observability/dist/chunks/chunk-VIS2X3AA.mjs + 1 modules
var chunk_VIS2X3AA = __webpack_require__(34654);
// EXTERNAL MODULE: ../shared-fe/es/railsEnv.mjs
var es_railsEnv = __webpack_require__(36544);
;// CONCATENATED MODULE: ../shared-fe/es/faviconPath.mjs

//#region src/faviconPath.ts
var faviconPath = ({ admin, railsEnv } = {}) => {
	const env = railsEnv || (0,es_railsEnv/* getRailsEnv */.YE)();
	if (admin) {
		if (env === "development") return "https://images.opendoor.com/source/s3/imgdrop-production/1bd03e41b990465e93d1c5b90ba36c16.png?service=shared-fe&preset=square-48";
		else if (env === "staging") return "https://images.opendoor.com/source/s3/imgdrop-production/a8dddd737aeb4780bf9e8edfa8bdc27b.png?service=shared-fe&preset=square-48";
		else if (env === "qa") return "https://images.opendoor.com/source/s3/imgdrop-production/28c43a220c9247f1ba3764c6aa7f67b3.png?service=shared-fe&preset=square-48";
		return "https://images.opendoor.com/source/s3/imgdrop-production/6f05fac182304e3d821592580acf3a68.png?service=shared-fe&preset=square-48";
	}
	if (env === "development") return "https://images.opendoor.com/source/s3/imgdrop-production/4ec068f491b4478293d83b56911a2f65.png?service=shared-fe&preset=square-48";
	else if (env === "staging") return "https://images.opendoor.com/source/s3/imgdrop-production/006a1ec0195a4e95bea9bd906d99130c.png?service=shared-fe&preset=square-48";
	else if (env === "qa") return "https://images.opendoor.com/source/s3/imgdrop-production/5618f1f758be4937861351a1c96548d6.png?service=shared-fe&preset=square-48";
	return "https://images.opendoor.com/source/s3/imgdrop-production/cf88fd37a91e43b0b7aafe6b076d2810.png?service=shared-fe&preset=square-48";
};
//#endregion


//# sourceMappingURL=faviconPath.mjs.map
// EXTERNAL MODULE: ./src/cms/index.ts + 1 modules
var cms = __webpack_require__(68385);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(79758);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/Layout.tsx + 10 modules
var Layout = __webpack_require__(9074);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/header/glass/constants.ts
var constants = __webpack_require__(198);
// EXTERNAL MODULE: ./src/components/shared/performance/preloads.ts
var preloads = __webpack_require__(37968);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.29.0_@types+react-dom@18.3.7_@types+react@18.3.28__@types+rea_8a835da27f6bd732d06ca598c0c17f05/node_modules/next/head.js
var head = __webpack_require__(62071);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/schema/index.ts
var HOMEPAGE_SCHEMA = {
    "@context": "http://schema.org",
    "@type": "Organization",
    legalName: "Opendoor Labs, Inc.",
    alternateName: "Opendoor",
    url: "https://www.opendoor.com",
    contactPoint: {
        "@type": "ContactPoint",
        telephone: "+1-888-352-7075",
        contactType: "Customer Service"
    },
    address: {
        "@type": "PostalAddress",
        addressLocality: "San Francisco",
        addressCountry: "USA",
        postalCode: "94104",
        streetAddress: "1 Post St, Fl 11"
    },
    logo: "https://www.opendoor.com/w/wp-content/uploads/2019/04/Opendoor-Logo.jpg",
    sameAs: [
        "https://www.facebook.com/OpendoorHQ",
        "https://twitter.com/opendoor",
        "https://www.youtube.com/channel/UCKKVV4bx18EtclsdNOFzWBw",
        "https://www.linkedin.com/company/opendoor-com",
        "https://www.pinterest.com/opendoorhq",
        "https://en.wikipedia.org/wiki/Opendoor", 
    ]
};
var buildJobPostingSchema = function(job) {
    var schema = {
        "@context": "https://schema.org",
        "@type": "JobPosting",
        title: job.title,
        description: job.content,
        datePosted: job.first_published,
        hiringOrganization: {
            "@type": "Organization",
            name: "Opendoor",
            sameAs: "https://www.opendoor.com",
            logo: HOMEPAGE_SCHEMA.logo
        },
        jobLocation: {
            "@type": "Place",
            address: job.location.name
        },
        jobLocationType: job.location.name.toLowerCase().includes("remote") ? "TELECOMMUTE" : undefined,
        applicantLocationRequirements: job.location.name.toLowerCase().includes("remote") ? [
            {
                "@type": "Country",
                name: "US"
            },
            {
                "@type": "Country",
                name: "Canada"
            }, 
        ] : undefined
    };
    // Include baseSalary/employmentType from metadata if Greenhouse is configured with structured fields
    if (job.metadata) {
        var salaryMeta = job.metadata.find(function(m) {
            return [
                "salary_range",
                "salary",
                "compensation"
            ].includes(m.name.toLowerCase());
        });
        var employmentMeta = job.metadata.find(function(m) {
            return [
                "employment_type",
                "employment type"
            ].includes(m.name.toLowerCase());
        });
        if (salaryMeta === null || salaryMeta === void 0 ? void 0 : salaryMeta.value) schema.baseSalary = salaryMeta.value;
        if (employmentMeta === null || employmentMeta === void 0 ? void 0 : employmentMeta.value) schema.employmentType = employmentMeta.value;
    }
    // Remove undefined values
    return JSON.parse(JSON.stringify(schema));
};


;// CONCATENATED MODULE: ./src/pages/shared/LandingPageV2Layout.tsx














var HERO_IMAGE_FIELDS = {
    lpComponentHeroV2: [
        "imageDesktopUrl",
        "imageMobileUrl"
    ],
    lpComponentHeroV2WithMarkers: [
        "imageDesktopUrl",
        "imageMobileUrl"
    ],
    lpComponentHeroCard: [
        "desktopCardImage",
        "cardImage"
    ],
    lpComponentHeroCta: [
        "doorwayImageUrl"
    ]
};
var getHeroImageUrl = function(body) {
    if (!(body === null || body === void 0 ? void 0 : body.content)) return undefined;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = body.content[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var block = _step.value;
            var ref, ref1, ref2, ref3;
            if (block.nodeType !== "embedded-entry-block") continue;
            var target = (ref = block.data) === null || ref === void 0 ? void 0 : ref.target;
            var contentTypeId = target === null || target === void 0 ? void 0 : (ref1 = target.sys) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.contentType) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sys) === null || ref3 === void 0 ? void 0 : ref3.id;
            var imageFields = HERO_IMAGE_FIELDS[contentTypeId];
            if (!imageFields) continue;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = imageFields[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var field = _step1.value;
                    var ref4;
                    var url = target === null || target === void 0 ? void 0 : (ref4 = target.fields) === null || ref4 === void 0 ? void 0 : ref4[field];
                    if (typeof url === "string" && url) return url;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return undefined;
};
var getSeoBaseTags = function(fields) {
    var title = fields === null || fields === void 0 ? void 0 : fields.title;
    var metaDescription = fields === null || fields === void 0 ? void 0 : fields.metaDescription;
    var canonicalUrl = fields === null || fields === void 0 ? void 0 : fields.canonicalUrl;
    var robots = [];
    // only set these when they are explicitly set to false
    // otherwise assume indexing and follow should be allowed
    if ((fields === null || fields === void 0 ? void 0 : fields.index) === false) {
        robots.push("noindex");
    }
    if ((fields === null || fields === void 0 ? void 0 : fields.follow) === false) {
        robots.push("nofollow");
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                children: title !== null && title !== void 0 ? title : "Opendoor | Sell your home the minute you’re ready."
            }, "title"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "shortcut icon",
                href: faviconPath({
                    railsEnv: globals/* DEPLOY_ENV */.Zp
                }),
                type: "image/png"
            }),
            metaDescription ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                name: "description",
                content: metaDescription
            }, "description") : null,
            canonicalUrl ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "canonical",
                href: canonicalUrl
            }, "canonical") : null,
            robots.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                name: "robots",
                content: robots.join(",")
            }, "robots") : null
        ]
    });
};
var getOpenGraphTags = function(openGraphFields) {
    var url = openGraphFields.url, type = openGraphFields.type, title = openGraphFields.title, description = openGraphFields.description, image = openGraphFields.image, siteName = openGraphFields.siteName;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:title",
                content: title
            }, "og:title"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:type",
                content: type
            }, "og:type"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:url",
                content: url
            }, "og:url"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:image",
                content: image
            }, "og:image"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:description",
                content: description
            }, "og:description"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:site_name",
                content: siteName
            }, "og:site_name"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                name: "twitter:url",
                content: url
            }, "twitter:url"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                name: "twitter:title",
                content: title
            }, "twitter:title"),
            description && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                name: "twitter:description",
                content: description
            }, "twitter:description"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                name: "twitter:image",
                content: image
            }, "twitter:image")
        ]
    });
};
var getJobPostingSchemaFromLoaderData = function(idToLoaderData) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(idToLoaderData)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var loaderData = _step.value;
            if (loaderData === null || loaderData === void 0 ? void 0 : loaderData.jobPostingSchema) {
                return loaderData.jobPostingSchema;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
};
var getSeoOverrideFromLoaderData = function(idToLoaderData) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(idToLoaderData)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var loaderData = _step.value;
            if (loaderData === null || loaderData === void 0 ? void 0 : loaderData.seoOverride) {
                return loaderData.seoOverride;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
};
// True when a JD-style loader ran (entry has a `seoOverride` key) and explicitly
// returned a missing-job result — the Rippling fetch failed or the UUID was
// unknown. Lets the page wrapper short-circuit to a real 404 before caching, so
// stale links don't cache as 200 soft-404s at unique URLs.
var isMissingJobInLoaderData = function(idToLoaderData) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(idToLoaderData)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var loaderData = _step.value;
            if (loaderData && "seoOverride" in loaderData && loaderData.seoOverride === null) {
                return true;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
};
// when a no-code landing page needs to preload an image for performance reasons,
// it can include a `preloadImages` field in the loader data
// this function crunches the loader data and pulls out all the preload images
// so that the top-level page can include those preload urls in the Head section
var getPreloadsFromLoaderData = function(idToLoaderData) {
    return Object.values(idToLoaderData).map(function(loaderData) {
        return loaderData === null || loaderData === void 0 ? void 0 : loaderData.preloadImages;
    }).filter(function(preload) {
        return preload;
    }).flat();
};
var getLandingpageV2ServerSideProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(context) {
        var ref, pageNum, slug, props, showModal, excludedSlugs, modalProps, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!((ref = context.params) === null || ref === void 0 ? void 0 : ref.slug)) {
                        return [
                            2,
                            {
                                notFound: true
                            }
                        ];
                    }
                    pageNum = 1;
                    if (context.query.page) {
                        pageNum = parseInt(context.query.page);
                    }
                    if (pageNum < 1) pageNum = 1;
                    slug = "";
                    // if slug is a string and not an array
                    if (typeof context.query.slug === "string") {
                        slug = context.query.slug;
                    } else if (Array.isArray(context.query.slug)) {
                        slug = context.query.slug.join("/");
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        (0,cms/* fetchLandingPageV2BySlug */.AL)({
                            slug: slug,
                            requestUrl: context.resolvedUrl,
                            pageNum: pageNum,
                            locale: "en-US"
                        })
                    ];
                case 2:
                    props = _state.sent();
                    if (!props) {
                        return [
                            2,
                            {
                                notFound: true
                            }
                        ];
                    }
                    // check if the page is set to public, and reject if appropriate
                    // this is intended to block non-public pages from being directly accessed by users,
                    // while still letting them be used in experiments as treatments
                    if (context.query.public && props.public === false) {
                        return [
                            2,
                            {
                                notFound: true
                            }
                        ];
                    }
                    showModal = false;
                    excludedSlugs = [
                        "builder",
                        "agent",
                        "real-estate",
                        "homepage",
                        "login",
                        "register",
                        "reset-password",
                        "calculator",
                        "careers",
                        "safety",
                        "privacy"
                    ];
                    if (!excludedSlugs.every(function(excluded) {
                        return !slug.includes(excluded);
                    })) return [
                        3,
                        4
                    ];
                    showModal = true;
                    return [
                        4,
                        (0,cms/* getCashOfferModal */.Mq)()
                    ];
                case 3:
                    modalProps = _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2,
                        {
                            props: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                                modalFields: showModal && modalProps ? {
                                    title: modalProps.fields.title,
                                    description: modalProps.fields.description,
                                    analyticsId: modalProps.fields.analyticsId
                                } : null,
                                showModal: !!(showModal && modalProps)
                            })
                        }
                    ];
                case 5:
                    e = _state.sent();
                    // eslint-disable-next-line no-console
                    console.error(e);
                    return [
                        2,
                        {
                            notFound: true
                        }
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return function getLandingpageV2ServerSideProps(context) {
        return _ref.apply(this, arguments);
    };
}();
var LandingPageV2Layout = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27;
    var contextualData = {
        landingPageSlug: props.fields.slug
    };
    var fields = props.fields;
    var isTreatmentHeader = (ref = fields.body) === null || ref === void 0 ? void 0 : (ref1 = ref.content) === null || ref1 === void 0 ? void 0 : ref1.some(function(node) {
        var ref, ref1, ref2;
        return (0,constants/* isTreatmentAnalyticsId */.Zl)((ref = node.data) === null || ref === void 0 ? void 0 : (ref1 = ref.target) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.fields) === null || ref2 === void 0 ? void 0 : ref2.analyticsId);
    });
    var imagePreloads = (0,preloads/* getContentPageImagePreloads */.Z)(props.idToLoaderData);
    var jobPostingSchema = getJobPostingSchemaFromLoaderData(props.idToLoaderData);
    var seoOverride = getSeoOverrideFromLoaderData(props.idToLoaderData);
    var _metaDescription;
    var seoBaseFields = seoOverride ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (ref2 = props.fields.seoBase) === null || ref2 === void 0 ? void 0 : ref2.fields), {
        title: seoOverride.title,
        canonicalUrl: seoOverride.canonicalUrl,
        metaDescription: (_metaDescription = seoOverride.metaDescription) !== null && _metaDescription !== void 0 ? _metaDescription : (ref3 = props.fields.seoBase) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fields) === null || ref4 === void 0 ? void 0 : ref4.metaDescription
    }) : (ref5 = props.fields.seoBase) === null || ref5 === void 0 ? void 0 : ref5.fields;
    var _ogTitle, _ogUrl, _ogDescription, ref28, ref29, ref30, ref31, ref32;
    var openGraphFields = seoOverride ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (ref6 = props.fields.openGraph) === null || ref6 === void 0 ? void 0 : ref6.fields), {
        title: (_ogTitle = seoOverride.ogTitle) !== null && _ogTitle !== void 0 ? _ogTitle : seoOverride.title,
        url: (_ogUrl = seoOverride.ogUrl) !== null && _ogUrl !== void 0 ? _ogUrl : seoOverride.canonicalUrl,
        description: (ref29 = (ref28 = (_ogDescription = seoOverride.ogDescription) !== null && _ogDescription !== void 0 ? _ogDescription : seoOverride.metaDescription) !== null && ref28 !== void 0 ? ref28 : (ref7 = props.fields.openGraph) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.fields) === null || ref8 === void 0 ? void 0 : ref8.description) !== null && ref29 !== void 0 ? ref29 : "",
        type: (ref30 = (ref9 = props.fields.openGraph) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.fields) === null || ref10 === void 0 ? void 0 : ref10.type) !== null && ref30 !== void 0 ? ref30 : "website",
        image: (ref31 = (ref11 = props.fields.openGraph) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.fields) === null || ref12 === void 0 ? void 0 : ref12.image) !== null && ref31 !== void 0 ? ref31 : "https://www.opendoor.com/icons/opendoor-logo.svg",
        siteName: (ref32 = (ref13 = props.fields.openGraph) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.fields) === null || ref14 === void 0 ? void 0 : ref14.siteName) !== null && ref32 !== void 0 ? ref32 : "Opendoor"
    }) : (ref15 = props.fields.openGraph) === null || ref15 === void 0 ? void 0 : ref15.fields;
    var heroImage = !openGraphFields ? getHeroImageUrl(props.fields.body) : undefined;
    var appleStatusBarColor = props.fields.slug === "homepage-syw-v2-home-guide" ? "black" : "default";
    var shouldIncludeTrustpilot = (ref16 = props.fields) === null || ref16 === void 0 ? void 0 : ref16.shouldShowTrustpilotReviews;
    // Check if this is a market page (slug format: landing-pages-v2/market-[market])
    var isMarketPage = props.fields.slug.startsWith("landing-pages-v2/market-");
    // Convert Contentful slug to public URL format for markdown alternate link
    var publicSlug = isMarketPage ? props.fields.slug.replace(/^landing-pages-v2\/market-/, "/sell/") : null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chunk_VIS2X3AA/* AddContextualData */.up, {
        data: contextualData,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
                children: [
                    getSeoBaseTags(seoBaseFields),
                    openGraphFields ? getOpenGraphTags(openGraphFields) : seoBaseFields && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            seoBaseFields.title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                property: "og:title",
                                content: seoBaseFields.title
                            }, "og:title"),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                property: "og:type",
                                content: "website"
                            }, "og:type"),
                            seoBaseFields.canonicalUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                property: "og:url",
                                content: seoBaseFields.canonicalUrl
                            }, "og:url"),
                            seoBaseFields.metaDescription && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                property: "og:description",
                                content: seoBaseFields.metaDescription
                            }, "og:description"),
                            heroImage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                property: "og:image",
                                content: heroImage
                            }, "og:image"),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                property: "og:site_name",
                                content: "Opendoor"
                            }, "og:site_name"),
                            seoBaseFields.title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                name: "twitter:title",
                                content: seoBaseFields.title
                            }, "twitter:title"),
                            seoBaseFields.metaDescription && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                name: "twitter:description",
                                content: seoBaseFields.metaDescription
                            }, "twitter:description"),
                            seoBaseFields.canonicalUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                name: "twitter:url",
                                content: seoBaseFields.canonicalUrl
                            }, "twitter:url"),
                            heroImage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                                name: "twitter:image",
                                content: heroImage
                            }, "twitter:image")
                        ]
                    }),
                    isMarketPage && publicSlug && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        id: "markdown-alternate",
                        rel: "alternate",
                        type: "text/markdown",
                        href: "".concat(publicSlug, ".md")
                    }, "markdown-alternate"),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        name: "apple-mobile-web-app-status-bar-style",
                        content: appleStatusBarColor
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(HOMEPAGE_SCHEMA)
                        }
                    }),
                    props.fields.jsonLdSchema && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(props.fields.jsonLdSchema).replace(/</g, "\\u003c")
                        }
                    }),
                    jobPostingSchema && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(jobPostingSchema).replace(/</g, "\\u003c")
                        }
                    }),
                    shouldIncludeTrustpilot && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                        type: "text/javascript",
                        src: "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js",
                        async: true
                    }),
                    imagePreloads.map(function(h) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                            rel: "preload",
                            as: "image",
                            href: h.fallbackSrc,
                            media: h.media,
                            imageSrcSet: h.srcSet,
                            fetchPriority: "high"
                        }, h.key);
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Layout/* default */.Z, {
                header: (ref17 = props.fields) === null || ref17 === void 0 ? void 0 : ref17.header,
                slug: "/".concat((ref18 = props.fields) === null || ref18 === void 0 ? void 0 : ref18.slug),
                footer: (ref19 = props.fields) === null || ref19 === void 0 ? void 0 : ref19.footer,
                showModal: props.showModal,
                modalTitle: (ref20 = props.modalFields) === null || ref20 === void 0 ? void 0 : ref20.title,
                modalDescription: (ref21 = props.modalFields) === null || ref21 === void 0 ? void 0 : ref21.description,
                modalAnalyticsId: (ref22 = props.modalFields) === null || ref22 === void 0 ? void 0 : ref22.analyticsId,
                extraLegalText: (ref23 = props.fields) === null || ref23 === void 0 ? void 0 : ref23.extraLegalText,
                showEligibilityLegal: (ref24 = props.fields) === null || ref24 === void 0 ? void 0 : ref24.showEligibilityLegal,
                showCustomerTestimonialLegal: (ref25 = props.fields) === null || ref25 === void 0 ? void 0 : ref25.showCustomerTestimonialLegal,
                showThePdpCopyrightLegal: (ref26 = props.fields) === null || ref26 === void 0 ? void 0 : ref26.showThePdpCopyrightLegal,
                showPromotionLegal: (ref27 = props.fields) === null || ref27 === void 0 ? void 0 : ref27.showPromotionLegal,
                headerVariant: isTreatmentHeader ? "treatment" : undefined,
                children: props.children
            })
        ]
    });
};
/* harmony default export */ var shared_LandingPageV2Layout = (LandingPageV2Layout);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3985,2211,9115,5959,820,6683,8806,650,5904,2063,8748,3335,6184,2956,1584,2276,641,5370,5954,589,5337,7987,8772,5208,9074,9774,2888,179], function() { return __webpack_exec__(21152); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);